import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HedaCoreUtilModule } from '@heda/core-util';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { TemplateLibModule } from 'app/mdm/template/template-lib.module';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';
import { SmsTestComponent } from 'app/pechkin/test/containers/sms-test.component';
import { PechkinService } from 'app/pechkin/test/services/pechkin.service';
import { EmailTestComponent } from 'app/pechkin/test/containers/email-test.component';

export const TEST_ROUTES: Routes = [
  { path: 'sms', component: SmsTestComponent },
  { path: 'email', component: EmailTestComponent },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    HedaCoreHospitalUiModule,
    HedaCoreUtilModule,
    TerminologyLibModule,
    TemplateLibModule,
  ],
  declarations: [EmailTestComponent, SmsTestComponent],
  providers: [PechkinService],
  exports: [],
})
export class TestModule {}
